import React, { PropsWithChildren } from "react";
import clsx from "clsx";

import useStyles from "./styles";

interface IProps {
  className?: string;
}

const NoContent = (props: PropsWithChildren<IProps>) => {
  const { className, children = "No Content" } = props;
  const classes = useStyles();

  return <div className={clsx(classes.noContent, className)}>{children}</div>;
};

export default React.memo(NoContent);
